<template>
  <div class="product-template __donate __limited-edu">

    <h1 data-v-1f20e9ef="" class="text-center mb-20">
      <img src="/static/img/limited-edu/logo-lmt-01.png" alt="Limited Education" width="260px" class="pd-15 ma-auto d-block" />
      </h1>

    <div class="container pd-sm-0">
      <div class="col-md-push-2 col-md-10 col-lg-push-2 col-md-8">
        <div class="product product--inline">
          <div class="product__block--form ">
            <div class="radius block shadow ">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />




              <div class="form__wrapper mt-15 mb-15">
                <div class="form__section">
                  <label class="form__radio-lg">
                    ไม่ต้องการรับของ
                    <input class="" type="radio" name="optionsRadios" value="" v-model="attributes.info.rewardProduct"  />
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->

                <div class="form__section">
                  <label class="form__radio-lg" :class="{disable: isRewardDisabled}">
                    รับเสื้อยืดรุ่นพิเศษ สกรีนชื่อของคุณแบบ Personalised ได้ <small>พร้อมจัดส่งให้ถึงบ้านหลังจากจบโครงการ (บริจาค 500 บาทขึ้นไป)</small>
                    <input class="" type="radio" name="optionsRadios" value="Customized T-Shirt" :disabled="isRewardDisabled" v-model="attributes.info.rewardProduct" />
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->

                <transition name="slide-down">
                  <div class="slide-down-wrapper" :class="{disable: product.price < 500}" v-show="attributes.info.rewardProduct === 'Customized T-Shirt'">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--lmt-deu">
                        <div class="">
                          <div class="">
                            <img src="/static/img/limited-edu/lmt-edu-shirt-01.png" alt="Limited Education" width="90%" class="ma-auto d-block pd-15" />
                          </div>
                          <transition name="slide-down">
                            <div v-if="attributes.info.rewardProduct === 'Customized T-Shirt'">
                              <div class="form__item--block">
                                <label class="form__label" for="lmt-name"><strong>คำที่ต้องการสกรีน</strong>&nbsp;<span class="fs-xs text-remark">(ภาษาไทยเท่านั้น - ไม่เกิน 11 ตัวอักษร)</span></label>
                                <input class="form__text" type="text" :disabled="isRewardDisabled" name="lmt-name" id="lmt-name" v-model.trim="attributes.info.rewardConfigText" placeholder="กรุณาพิมพ์คำที่ต้องการให้สกรีนบนเสื้อ" />
                                <div class="alert alert--error" v-if="error.rewardConfigText">ภาษาไทยเท่านั้น ไม่เกิน 11 ตัวอักษร</div>
                              </div>
                              <div class="form__item--block">
                                <div class="form__label"><strong>ขนาดเสื้อ</strong></div>
                                <div class="form__btn-group form__btn-group--inline" :class="{disable: product.price < 500}">
                                  <div class="form__btn-group-item" :class="{active: attributes.info.rewardConfigSize==='s'}">
                                    <label class="btn btn-size">
                                      S
                                      <input type="radio" name="size" value="s" v-model="attributes.info.rewardConfigSize" :disabled="isRewardDisabled" />
                                      <div class="text-remark">รอบอก 36 นิ้ว</div>
                                    </label>
                                  </div>
                                  <div class="form__btn-group-item" :class="{active: attributes.info.rewardConfigSize==='m'}">
                                    <label class="btn btn-size">
                                      M
                                      <input type="radio" name="size" value="m" v-model="attributes.info.rewardConfigSize" :disabled="isRewardDisabled" />
                                      <div class="text-remark">รอบอก 38 นิ้ว</div>
                                    </label>
                                  </div>
                                  <div class="form__btn-group-item" :class="{active: attributes.info.rewardConfigSize==='f'}">
                                    <label class="btn btn-size">
                                      F
                                      <input type="radio" name="size" value="f" v-model="attributes.info.rewardConfigSize" :disabled="isRewardDisabled" />
                                      <div class="text-remark">รอบอก 40 นิ้ว</div>
                                    </label>
                                  </div>
                                  <div class="form__btn-group-item" :class="{active: attributes.info.rewardConfigSize==='l'}">
                                    <label class="btn btn-size">
                                      L
                                      <input type="radio" name="size" value="l" v-model="attributes.info.rewardConfigSize" :disabled="isRewardDisabled" />
                                      <div class="text-remark">รอบอก 42 นิ้ว</div>
                                    </label>
                                  </div>
                                  <div class="form__btn-group-item" :class="{active: attributes.info.rewardConfigSize==='xl'}">
                                    <label class="btn btn-size">
                                      XL
                                      <input type="radio" name="size" value="xl" v-model="attributes.info.rewardConfigSize" :disabled="isRewardDisabled" />
                                      <div class="text-remark">รอบอก 44 นิ้ว</div>
                                    </label>
                                  </div>

                                  <div class="alert alert--error" v-if="error.rewardConfigSize">กรุณาเลือกขนาดเสื้อ</div>

                                </div>
                              </div>
                            </div>
                          </transition>
                        </div>
                      </div>
                    </div> <!-- end form_section -->
                  </div>
                </transition>

                <div class="form__section">
                  <label class="form__radio-lg" :class="{disable: isRewardDisabled}">
                    รับเสื้อยืดรุ่นพิเศษจาก ad addict <small>พร้อมจัดส่งให้ถึงบ้านหลังจากจบโครงการ (บริจาค 500 บาทขึ้นไป)</small>
                    <input class="" type="radio" name="optionsRadios" value="ad-addict" :disabled="isRewardDisabled" v-model="attributes.info.rewardProduct" />
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->
                <transition name="slide-down">
                  <div class="slide-down-wrapper" :class="{disable: product.price < 500}" v-show="attributes.info.rewardProduct === 'ad-addict'">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--lmt-deu">
                        <div class="wrapper-form__item--scroll">
                          <div class="block radius border mb-10">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  เสื้อยืดรุ่นพิเศษ จาก ad addict "ลูกค้าแอพพรูปค่ะ"
                                  <div class="text-remark"></div>
                                  <input class="" type="radio" name="radio-t-shirt_addict" value="เสื้อยืดรุ่นพิเศษ จาก ad addict ลูกค้าแอพพรูปค่ะ" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                  <div class="mt-15">ขนาดเสื้อ</div>
                                  <div class="form__select">
                                    <select v-model="attributes.info.rewardConfigSize">
                                      <option value="">-- เลือกขนาด --</option>
                                      <option value="s">S - รอบอก 36 นิ้ว</option>
                                      <option value="m">M - รอบอก 38 นิ้ว</option>
                                      <option value="f">F - รอบอก 40 นิ้ว</option>
                                      <option value="l">L - รอบอก 42 นิ้ว</option>
                                      <option value="xl">XL - รอบอก 44 นิ้ว</option>
                                    </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.rewardConfigSize">กรุณาเลือกขนาดเสื้อ</div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile" @click.prevent="showImage('/static/img/limited-edu/shirt1_ad.png')">
                                    <img src="/static/img/limited-edu/lmt-product-ad-01.jpg" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-01 -->
                          <div class="block radius border mb-10">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  เสื้อยืดรุ่นพิเศษ จาก ad addict "ลูกค้าชอบแล้วค่ะ"
                                  <div class="text-remark"></div>
                                  <input :disabled="isRewardDisabled" class="" type="radio" name="radio-t-shirt_addict" value="เสื้อยืดรุ่นพิเศษ จาก ad addict ลูกค้าชอบแล้วค่ะ" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                  <div class="mt-15">ขนาดเสื้อ</div>
                                  <div class="form__select">
                                    <select v-model="attributes.info.rewardConfigSize">
                                      <option value="">-- เลือกขนาด --</option>
                                      <option value="s">S - รอบอก 36 นิ้ว</option>
                                      <option value="m">M - รอบอก 38 นิ้ว</option>
                                      <option value="f">F - รอบอก 40 นิ้ว</option>
                                      <option value="l">L - รอบอก 42 นิ้ว</option>
                                      <option value="xl">XL - รอบอก 44 นิ้ว</option>
                                    </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.rewardConfigSize">กรุณาเลือกขนาดเสื้อ</div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile" @click.prevent="showImage('/static/img/limited-edu/shirt2_ad.png')">
                                    <img src="/static/img/limited-edu/lmt-product-ad-02.jpg" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-02 -->
                          <div class="block radius border mb-10">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  เสื้อยืดรุ่นพิเศษ จาก ad addict "ไอเดียนี้พี่ชอบค่ะ"
                                  <div class="text-remark"></div>
                                  <input :disabled="isRewardDisabled" class="" type="radio" name="radio-t-shirt_addict" value="เสื้อยืดรุ่นพิเศษ จาก ad addict ไอเดียนี้พี่ชอบค่ะ" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                  <div class="mt-15">ขนาดเสื้อ</div>
                                  <div class="form__select">
                                    <select v-model="attributes.info.rewardConfigSize">
                                      <option value="">-- เลือกขนาด --</option>
                                      <option value="s">S - รอบอก 36 นิ้ว</option>
                                      <option value="m">M - รอบอก 38 นิ้ว</option>
                                      <option value="f">F - รอบอก 40 นิ้ว</option>
                                      <option value="l">L - รอบอก 42 นิ้ว</option>
                                      <option value="xl">XL - รอบอก 44 นิ้ว</option>
                                    </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.rewardConfigSize">กรุณาเลือกขนาดเสื้อ</div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile" @click.prevent="showImage('/static/img/limited-edu/shirt3_ad.png')">
                                    <img src="/static/img/limited-edu/lmt-product-ad-03.jpg" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-03 -->
                          <div class="block radius border mb-10">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  เสื้อยืดรุ่นพิเศษ จาก ad addict "ใส่แล้วขายงานผ่าน"
                                  <div class="text-remark"></div>
                                  <input :disabled="isRewardDisabled" class="" type="radio" name="radio-t-shirt_addict" value="เสื้อยืดรุ่นพิเศษ จาก ad addict ใส่แล้วขายงานผ่าน" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                  <div class="mt-15">ขนาดเสื้อ</div>
                                  <div class="form__select">
                                    <select v-model="attributes.info.rewardConfigSize">
                                      <option value="">-- เลือกขนาด --</option>
                                      <option value="s">S - รอบอก 36 นิ้ว</option>
                                      <option value="m">M - รอบอก 38 นิ้ว</option>
                                      <option value="f">F - รอบอก 40 นิ้ว</option>
                                      <option value="l">L - รอบอก 42 นิ้ว</option>
                                      <option value="xl">XL - รอบอก 44 นิ้ว</option>
                                    </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.rewardConfigSize">กรุณาเลือกขนาดเสื้อ</div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile" @click.prevent="showImage('/static/img/limited-edu/shirt4_ad.png')">
                                    <img src="/static/img/limited-edu/lmt-product-ad-04.jpg" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-04 -->
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>

                <div class="form__section">
                  <label class="form__radio-lg" :class="{disable: isRewardDisabled699}">
                    รับของที่ระลึกลายพิเศษ จากศิลปินใน Community Illustrator <small>คนที่คุณชื่นชอบ จัดส่งให้ถึงบ้านหลังจากจบโครงการทั้งหมด 17 ศิลปิน</small>
                    <input class="" type="radio" name="optionsRadios" value="merchandise" :disabled="isRewardDisabled699" v-model="attributes.info.rewardProduct" />
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->

                <transition name="slide-down">
                  <div class="slide-down-wrapper" :class="{disable: product.price < 699}" v-show="attributes.info.rewardProduct === 'merchandise'">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--lmt-deu">
                        <div class="wrapper-form__item--scroll">
                          <div class="block radius border mb-10 lmt-01">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  เสื้อยืดรุ่นพิเศษจาก Puck
                                  <div class="text-remark"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="เสื้อยืดรุ่นพิเศษจาก Puck" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                  <div class="mt-15">ขนาดเสื้อ</div>
                                  <div class="form__select">
                                    <select v-model="attributes.info.rewardConfigSize">
                                      <option value="">-- เลือกขนาด --</option>
                                      <option value="s">S - รอบอก 36 นิ้ว</option>
                                      <option value="m">M - รอบอก 38 นิ้ว</option>
                                      <option value="f">F - รอบอก 40 นิ้ว</option>
                                      <option value="l">L - รอบอก 42 นิ้ว</option>
                                      <option value="xl">XL - รอบอก 44 นิ้ว</option>
                                    </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.rewardConfigSize">กรุณาเลือกขนาดเสื้อ</div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--01" @click.prevent="showImage('/static/img/limited-edu/lmt-product-01_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-01.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-01 -->
                          <div class="block radius border mb-10 lmt-02">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  ชุดเข็มกลัดโลหะจาก Nut Dao
                                  <div class="text-remark mb-15">1 ชุดมีทั้งหมด 2 ชิ้น</div>
                                  <input class="" type="radio" name="radio-merchandise" value="ชุดเข็มกลัดโลหะจาก Nut Dao" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--02" @click.prevent="showImage('/static/img/limited-edu/lmt-product-02_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-02.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-02 -->
                          <div class="block radius border mb-10 lmt-03">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  ชุดเข็มกลัดอะคริลิคจาก Kanith
                                  <div class="text-remark mb-15">1 ชุดมีทั้งหมด 4 ชิ้น</div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="ชุดเข็มกลัดอะคริลิคจาก Kanith"  v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--03" @click.prevent="showImage('/static/img/limited-edu/lmt-product-03_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-03.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-03 -->
                          <div class="block radius border mb-10 lmt-04">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  ถุงผ้าแคนวาสจาก TUNA Dunn
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="ถุงผ้าแคนวาสจาก TUNA Dunn" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--04" @click.prevent="showImage('/static/img/limited-edu/lmt-product-04_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-04.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-04 -->
                          <div class="block radius border mb-10 lmt-05">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  Shopping Bag จาก Benxblues
                                  <div class="text-remark mb-15">ถุงผ้าร่มแบบพกพาพับได้</div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="Shopping Bag จาก Benxblues" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--05" @click.prevent="showImage('/static/img/limited-edu/lmt-product-05_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-05.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-05 -->
                          <div class="block radius border mb-10 lmt-06">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  โปสเตอร์จาก Nakrob Moonmanas
                                  <div class="text-remark mb-15">งานพิมพ์ Digital Collage ขนาด A2</div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="โปสเตอร์จาก Nakrob Moonmanas" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--06" @click.prevent="showImage('/static/img/limited-edu/lmt-product-06_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-06.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-06 -->
                          <div class="block radius border mb-10 lmt-07">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  เสื้อยืดรุ่นพิเศษจาก Juli Baker and Summer
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="เสื้อยืดรุ่นพิเศษจาก Juli Baker and Summer" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                  <div class="mt-15">ขนาดเสื้อ</div>
                                  <div class="form__select">
                                    <select v-model="attributes.info.rewardConfigSize">
                                      <option value="">-- เลือกขนาด --</option>
                                      <option value="s">S - รอบอก 36 นิ้ว</option>
                                      <option value="m">M - รอบอก 38 นิ้ว</option>
                                      <option value="f">F - รอบอก 40 นิ้ว</option>
                                      <option value="l">L - รอบอก 42 นิ้ว</option>
                                      <option value="xl">XL - รอบอก 44 นิ้ว</option>
                                    </select>
                                  </div>
                                  <div class="alert alert--error" v-if="error.rewardConfigSize">กรุณาเลือกขนาดเสื้อ</div>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--07" @click.prevent="showImage('/static/img/limited-edu/lmt-product-07_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-07.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-07 -->
                          <div class="block radius border mb-10 lmt-08">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  โปสเตอร์จาก LoveSyrup
                                  <div class="text-remark mb-15">งานพิมพ์ ขนาด A2</div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="โปสเตอร์จาก LoveSyrup" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--08" @click.prevent="showImage('/static/img/limited-edu/lmt-product-08_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-08.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-08 -->
                          <div class="block radius border mb-10 lmt-09">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  ถุงผ้าแคนวาสจาก Tum Ulit
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="ถุงผ้าแคนวาสจาก Tum Ulit" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--09" @click.prevent="showImage('/static/img/limited-edu/lmt-product-09_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-09.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-09 -->
                          <div class="block radius border mb-10 lmt-10">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  หมวกปักลายจาก Banana Blah Blah
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="หมวกปักลายจาก Banana Blah Blah" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--10" @click.prevent="showImage('/static/img/limited-edu/lmt-product-10_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-10.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-10 -->
                          <div class="block radius border mb-10 lmt-11">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  แก้วกาแฟจาก Jeep Kongdechakul
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="แก้วกาแฟจาก Jeep Kongdechakul" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--11" @click.prevent="showImage('/static/img/limited-edu/lmt-product-11_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-11.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-11 -->
                          <div class="block radius border mb-10 lmt-12">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  ถุงผ้าแคนวาสจาก Cus Cus
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="ถุงผ้าแคนวาสจาก Cus Cus" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--12" @click.prevent="showImage('/static/img/limited-edu/lmt-product-12_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-12.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-12 -->
                          <div class="block radius border mb-10 lmt-13">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  ชุดโปสการ์ดและ Masking Tape จาก Louis Sketcher
                                  <div class="text-remark mb-15">โปสการ์ด 5 ชิ้น + Maskting Tape 1 ชิ้น</div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="ชุดโปสการ์ดและ Masking Tape จาก Louis Sketcher" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--13" @click.prevent="showImage('/static/img/limited-edu/lmt-product-13_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-13.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-13 -->
                          <div class="block radius border mb-10 lmt-14">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  หมอนไดคัทจาก Apolar
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="หมอนไดคัทจาก Apolar" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--14" @click.prevent="showImage('/static/img/limited-edu/lmt-product-14_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-14.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-14 -->
                          <div class="block radius border mb-10 lmt-15">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  หมอนไดคัทจาก Sahred Toy
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="หมอนไดคัทจาก Sahred Toy" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--15" @click.prevent="showImage('/static/img/limited-edu/lmt-product-15_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-15.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-15 -->
                          <div class="block radius border mb-10 lmt-16">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  ถุงผ้าแคนวาสจาก Munin
                                  <div class="text-remark mb-15"></div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="ถุงผ้าแคนวาสจาก Munin" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--16" @click.prevent="showImage('/static/img/limited-edu/lmt-product-16_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-16.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-16 -->
                          <div class="block radius border mb-10 lmt-17">
                            <label class="form__radio-lg form__radio-lg--sub">
                              <div class="row">
                                <div class="col-12 col-md-9">
                                  ชุดหนังสือและเครื่องเขียนจาก Sa-ard
                                  <div class="text-remark mb-15">หนังสือ 'การศึกษาของกระป๋องมีฝัน' + ชุดเครื่องเขียน Grey Ray</div>
                                  <input :disabled="isRewardDisabled699" class="" type="radio" name="radio-merchandise" value="ชุดหนังสือและเครื่องเขียนจาก Sa-ard" v-model="attributes.info.rewardConfigChoice" />
                                  <span class="checkmark"></span>
                                </div>
                                <div class="col-12 col-md-3">
                                  <div class="lmt-profile lmt-profile--17" @click.prevent="showImage('/static/img/limited-edu/lmt-product-17_full.jpg')">
                                    <img src="/static/img/limited-edu/lmt-product-17.png" alt="" />
                                  </div>
                                </div>
                              </div>
                            </label>
                          </div><!-- end form section product-17 -->
                        </div><!-- end wrapper scroll -->
                      </div>
                    </div> <!-- end form_section -->
                  </div>
                </transition>


              </div><!-- end form wrapper -->

              <donor-info v-model="attributes.info.name"
                class="pt-15" />

              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />

              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'

  const needSizeProducts = ['เสื้อยืดรุ่นพิเศษจาก Puck', 'เสื้อยืดรุ่นพิเศษจาก Juli Baker and Summer']

  export default {
    name: 'ProductTemplateLimitedEducation',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        attributes: {
          info: {
            name: '',
            rewardProduct: '',
            rewardConfigText: '',
            rewardConfigSize: '',
            rewardConfigChoice: ''
          },
          page: ''
        },
        isRewardDisabled: false,
        isRewardDisabled699: false,
        error: {
          rewardConfigText: false,
          rewardConfigSize: false
        }
      }
    },

    created () {
      this.checkReward(this.product.price)
    },

    methods: {
      validate () {
        this.error.rewardConfigText = false
        this.error.rewardConfigSize = false

        let valid = true
        const {info} = this.attributes
        if (info.rewardProduct === null) {
          this.error.rewardProduct = true
          valid = false
        } else if (info.rewardProduct === 'Customized T-Shirt') {
          if (!info.rewardConfigText.match(/^[\u0e01-\u0e5b]{1,11}$/)) {
            this.error.rewardConfigText = true
            valid = false
          }
          if (!info.rewardConfigSize) {
            this.error.rewardConfigSize = true
            valid = false
          }
        } else if (info.rewardProduct === 'merchandise') {
          if (needSizeProducts.indexOf(info.rewardConfigChoice) > -1 && !info.rewardConfigSize) {
            this.error.rewardConfigSize = true
            valid = false
          }
        }
        return valid
      },
      donate () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        if (!this.validate()) {
          return
        }

        this.$store.dispatch('clearCart').then(() => {
          this.$refs.cartAction.buyNow()
        })
      },
      checkReward (amount) {
        if (amount >= 699) {
          this.isRewardDisabled = false
          this.isRewardDisabled699 = false
        } else if (amount < 699 && amount >= 500) {
          if (this.attributes.info.rewardProduct === 'merchandise') {
            this.attributes.info.rewardProduct = null
            this.attributes.info.rewardConfigText = ''
            this.attributes.info.rewardConfigSize = ''
          }
          this.isRewardDisabled = false
          this.isRewardDisabled699 = true
        } else {
          this.attributes.info.rewardProduct = null
          this.attributes.info.rewardConfigText = ''
          this.attributes.info.rewardConfigSize = ''
          this.isRewardDisabled = true
          this.isRewardDisabled699 = true
        }
      },
      showImage (src) {
        this.$modal.show({
          text: `<img class="img-enlarged" src="${src}" />`,
          okButtonText: 'ปิด'
        })
      }
    },

    watch: {
      'product.price': function (amount) {
        this.checkReward(amount)
      },
      'attributes.info.rewardConfigChoice': function (v, p) {
        if (v) {
          // this.attributes.info.rewardProduct = 'merchandise'
        }
      },
      'attributes.info.rewardProduct': function (v, p) {
        if (v !== p && (v !== 'merchandise' && v !== 'ad-addict')) {
          this.attributes.info.rewardConfigChoice = ''
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
  }
</style>



// WEBPACK FOOTER //
// limited-education.vue?f8aee2ec